var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ml-2"},[_c('v-btn',{staticClass:"app-button-login body-2",attrs:{"text":"","dark":""},on:{"click":function($event){_vm.dialog = true}}},[_c('strong',[_vm._v(_vm._s(_vm.$vuetify.breakpoint.smAndDown
                ? _vm.$t('navbar.unauthenticated.join')
                : _vm.$t('navbar.unauthenticated.join_the_league')))])]),_c('sign-in-dialog',{attrs:{"open":_vm.dialog},on:{"update:open":function($event){_vm.dialog = !_vm.dialog}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }